'use strict';

angular.module('Components', []);


/** WEBPACK FOOTER **
 ** ./client/components/components.module.js
 **/